// extracted by mini-css-extract-plugin
module.exports = {"title":"Events_title__2jiLQ","subtitle":"Events_subtitle__3L7pV","button__container":"Events_button__container__29hOC","button":"Events_button__2fRQs"};